import React, { Component } from 'react';
import { Form, Button, Alert, Container, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { changePassword } from '../../actions/authenAction';
import { getTranslate, LANGUAGE_KEYS } from '../../utils/language';

class SetPassword extends Component {
  state = {
    newPassword: '',
    confirmPassword: '',
    error: null,
    success: false
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { newPassword, confirmPassword } = this.state;

    // Validate passwords
    if (newPassword !== confirmPassword) {
      this.setState({ error: getTranslate(LANGUAGE_KEYS.TEXT_PASSWORDS_DO_NOT_MATCH) });
      return;
    }

    if (newPassword.length < 6) {
      this.setState({ error: getTranslate(LANGUAGE_KEYS.TEXT_PASSWORD_TOO_SHORT) });
      return;
    }

    try {
      const success = await this.props.changePassword(newPassword);
      if (success) {
        this.setState({ 
          success: true,
          error: null,
          newPassword: '',
          confirmPassword: ''
        });
      } else {
        this.setState({ error: getTranslate(LANGUAGE_KEYS.TEXT_FAILED_SET_PASSWORD) });
      }
    } catch (err) {
      this.setState({ error: err.message || getTranslate(LANGUAGE_KEYS.TEXT_FAILED_SET_PASSWORD) });
    }
  };

  render() {
    const { newPassword, confirmPassword, error, success } = this.state;

    return (
      <Container>
        <Row className="justify-content-center mt-5">
          <Col md={6}>
            <h2 className="text-center mb-4">{getTranslate(LANGUAGE_KEYS.TEXT_SET_NEW_PASSWORD)}</h2>
            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">{getTranslate(LANGUAGE_KEYS.TEXT_PASSWORD_SET_SUCCESS)}</Alert>}
            <Form onSubmit={this.handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_NEW_PASSWORD)}</Form.Label>
                <Form.Control
                  type="password"
                  name="newPassword"
                  value={newPassword}
                  onChange={this.handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_CONFIRM_NEW_PASSWORD)}</Form.Label>
                <Form.Control
                  type="password"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={this.handleChange}
                  required
                />
              </Form.Group>
              <Button variant="primary" type="submit" className="w-100">
                {getTranslate(LANGUAGE_KEYS.TEXT_SET_PASSWORD)}
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default connect(null, { changePassword })(SetPassword); 